import SmoothScrollIntoView from '../__frontend/smoothScrollIntoView';
import setHeaderHeight from '../__frontend/setHeaderHeight';
import Forms from '../__frontend/forms';
import viewportUnits from '../__frontend/viewportUnits';
import delayedScripts from '../__frontend/delayedScripts';
import FormUTMCodes from '../__frontend/formUTMCodes';
import sectionsInView from '../__frontend/sectionsInView';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		SmoothScrollIntoView();
		setHeaderHeight();
		viewportUnits();
		delayedScripts();
		FormUTMCodes();
		sectionsInView();
	},
	loaded() {
		// Only add functions here that are okay to run after the entire page has loaded (include media/images).
		Forms();
		viewportUnits();
		FormUTMCodes();
	},
	resized() {
		viewportUnits();
		setHeaderHeight();
		sectionsInView();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
